import { render } from "./statusArchiveTask.vue?vue&type=template&id=563a170e"
import script from "./statusArchiveTask.vue?vue&type=script&lang=js"
export * from "./statusArchiveTask.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__